// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3YC1d","content":"styles_content__1h_wk"};